import { PlayerMix } from './player-mix.model';
import { PlayerShow } from './show.model';
import { PlayerHostBase } from './host-base.model';
import { Expose, Type } from 'class-transformer';

/**
 * Host/DJ
 */
export class PlayerHost extends PlayerHostBase {

  // to be added
  @Expose({name:'_mixes'}) //, [PlayerMix], PropertyConvertingMode.IGNORE_NULLABLE)
  @Type(() => PlayerMix)
  _mixes: PlayerMix [] = [];
  @Expose({name:'_last_show_mix'}) //, PlayerMix, PropertyConvertingMode.IGNORE_NULLABLE)
  @Type(() => PlayerMix)
  _lastShowMix: PlayerMix | undefined = undefined;
  @Expose({name:'_default_mix'}) //, PlayerMix, PropertyConvertingMode.IGNORE_NULLABLE)
  @Type(() => PlayerMix)
  _defaultMix: PlayerMix | undefined = undefined;
  @Expose({name:'_shows'}) //, [PlayerShow], PropertyConvertingMode.IGNORE_NULLABLE)
  @Type(() => PlayerShow)
  _shows: PlayerShow [] = [];

  @Expose({name:'_show_count'})
  _showCount = 0;
  @Expose({name:'_mix_count'})
  _mixCount = 0;

}
